import BaseSvg, { Props } from '../BaseSvg'

const Planimetry: React.FC<Props> = (props) => (
  <BaseSvg viewBox="0 0 18 18" {...props}>
    <path d="M4.125.75v1.5h9.75V.75H18v14.625a2.25 2.25 0 01-2.25 2.25H2.25A2.25 2.25 0 010 15.375V.75h4.125zm-1.5 1.5H1.5v11.003l-.02.007c.24-.087.5-.135.77-.135h1.875v1.5H2.25a.75.75 0 00-.056 1.498l.056.002h13.5a.75.75 0 00.056-1.498l-.056-.002h-1.875v-3.75H9.75V8.25h1.125v1.5h3v-6h-3v3.375H9.75V3.75H7.875v3.375H6.75V3.75H4.125v6H6.75v-1.5h1.125v3.375H6.75v-.75H4.125v2.25h-1.5V2.25zm9.75 10.5v1.125h-6.75V12.75h6.75zM16.5 2.25h-1.125v10.875h.375c.275 0 .539.05.782.14l-.032-.012V2.25z" />
  </BaseSvg>
)

export default Planimetry
